export default {
    api: {
        getNewsIndexList: {
            url: '/api.php/news/getNewsIndexList',
            method: 'get',
            // crosUrl:'/api',

            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        getActionList: {
            url: '/api.php/action/getActionList',
            method: 'get',
            // crosUrl:'/api',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        getUserIndexList: {
            url: '/api.php/user/getUserIndexList',
            method: 'get',
            // crosUrl:'/api',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //往期回顾
        getNewsPrevious: {
            url: '/api.php/news/getNewsPrevious',
            method: 'get',
            // crosUrl:'/api',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        getCityInfo: {
            url: '/api.php/city/getCityInfo',
            method: 'get',
            // crosUrl:'/api',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                        // console.log('beforeReq')
                },
                receiveRes(callback) {
                    callback && callback()
                        // console.log('receiveRes')
                },
            }
        },
        //微信授权
        getAuthorizeUrl: {
            url: '/api.php/user/getAuthorizeUrl',
            method: 'get',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                },
                receiveRes(callback) {
                    callback && callback()
                },
            }
        },
        //诚信商家
        getUserInfoByID: {
            url: '/api.php/user/getUserInfoByID',
            method: 'get',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                },
                receiveRes(callback) {
                    callback && callback()
                },
            }
        },
        //个人资料
        getUserInfoByUID: {
            url: '/api.php/user/getUserInfoByUID',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                },
                receiveRes(callback) {
                    callback && callback()
                },
            }
        },
        //底部
        getFootsList: {
            url: '/api.php/foots/getFootsList',
            method: 'post',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                },
                receiveRes(callback) {
                    callback && callback()
                },
            }
        },
        //底部详情
        getFootsByID: {
            url: '/api.php/foots/getFootsByID',
            method: 'get',
            hooks: {
                beforeReq(callback) {
                    callback && callback()
                },
                receiveRes(callback) {
                    callback && callback()
                },
            }
        },

    },
    hooks: {
        beforeContactReq(callback) {
            callback && callback()
        },
        receiveContactRes(callback) {
            callback && callback()
        }
    }
}